var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { classMap } from 'lit/directives/class-map.js';
import { styleMap } from 'lit/directives/style-map.js';
import { property, query } from "lit/decorators.js";
import { html, css, nothing } from "lit";
import { stringDecoder, json2Validate, stringDecoderLC, labelDecoder, booleanDecoder, PICValidate, customElement, PICBase, PIC, submitEventHandler, PICRequired, PICModal, PICDate, PICTime, PICDualDate, PICCustomError } from '../Internals';
let PICInput = class PICInput extends PICBase {
    set width(iwidth) {
        let widthParser = '160px';
        if (iwidth) {
            if (typeof iwidth == 'number' || iwidth.match(/^-?[0-9]*$/g)) {
                iwidth = parseFloat(iwidth);
                widthParser = iwidth + 'px';
            }
            else
                widthParser = iwidth;
        }
        this._width = widthParser;
        this.requestUpdate();
    }
    get width() {
        return this._width;
    }
    get submitValue() {
        return this.value;
    }
    /**
     * Method to call, or overrride in components to properly set values in that specific component.
     * Can have special handling that .value does not have...
     * @param value String representation of value...
     */
    setValue(value) {
        this.value = value;
    }
    constructor() {
        super();
        this.value = '';
        this.placeholder = '';
        this.label = '';
        this.icon = '';
        this.changeEvent = '';
        this.focus_ = false;
        this.validState = [];
        this.eType = 'old';
        this.density = 'old';
        this._width = '160px';
        this.userHasInteracted = false;
        this.isRunningSubmitEvent = false;
        this.label_ = html `&nbsp;`;
        this.valid = null;
        this.customError = null;
        this.actionElements = new Map();
        this.showFullError = false;
        this.hasEllipsis = false;
    }
    static get styles() {
        const defaultStyle = css `
            /* Old Style */
            :host {
                display: inline-block;
                box-sizing: border-box;
                --pic-innerInputBorderColor: var(--pic-onSurfaceMediumColor);
                --pic-innerInputBorderDisabledColor: var(--pic-blackOverlayFocusColor);
                --pic-innerInputBorderHoverColor: var(--pic-onSurfaceHighColor);
                --pic-innerInputBorderFocusColor: var(--pic-primaryColor);
                --pic-innerInputBorderInvalidColor: var(--pic-statusErrorColor);
                --pic-iconBottom: 2px;
            }
            .container {
                display: flex;
                flex-flow: column nowrap;
            }
            .icon {
                position: absolute;
                bottom: var(--pic-iconBottom);
                right: 3px;
                width: 17px;
                height: 17px;
            }
            .icon:not(.disabled):hover{
                cursor:pointer;
            }

            /* new style */
            .inner-input-old {
                width: 100%;
                height: 1.35rem;
                box-sizing: border-box;
                border: 1px solid black;
            }
            .inner-input-old.has-icon {
                padding-right: 20px;
            }
            .pic-inputLabel-default {
                position: relative;
                width: fit-content;
                height: 16px;
                left: 12px;
                top: 8px;
                padding: 0px 4px;
                background-color: var(--pic-backgroundColor, white);
                white-space: nowrap;
                transition-duration: 250ms;
                transition-property: all;
                transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
            }
            
            .inner-input-default {
                height: 100%;
                border-radius: 4px;
                border: 1px solid var(--pic-innerInputBorderColor);
                background-color: var(--pic-backgroundColor, white);
                outline: none;
                display: flex;
                align-items: center;
                text-overflow: ellipsis;
                box-sizing: border-box;
                padding-left: 14px;
                padding-right: 1px;
            }
            .inner-input-default:focus {
                border: 2px solid var(--pic-innerInputBorderFocusColor);
                padding-left: 13px;
                padding-right: 0;
            }
            .inner-input-default.has-icon {
                padding-right: 24px;
            }
            
            .inner-input-default:hover {
                border-color: var(--pic-innerInputBorderHoverColor);
            }
            
            .pic-inputLabel-default.disabled{
                color: var(--pic-disabledColor);
            }

            .inner-input-default:disabled {
                border-color: var(--pic-innerInputBorderDisabledColor);
                background-color: var(--pic-surfaceColor);
                color: var(--pic-disabledColor);
            }
            
            
            .inner-input-default:invalid {
                border-color: var(--pic-innerInputBorderInvalidColor);
                border-width: 2px;
                padding-left: 13px;
                padding-right: 0;
            }
            
            .pic-inputLabel-default.low {
                left: 12px;
                top: 32px;
                font-size: 16px;
                height: var(--pic-densityLowLabelHeight);
                background-color: transparent;
                overflow: hidden;
                text-overflow: ellipsis;
                width: calc(var(--pic-inputlength, 125px) - 5%);
            }
            .pic-inputLabel-default.medium {
                left: 12px;
                top: 27px;
                font-size: 16px;
                height: var(--pic-densityMediumLabelHeight);
                background-color: transparent;
                overflow: hidden;
                text-overflow: ellipsis;
                width: calc(var(--pic-inputlength, 125px) - 5%);
            }
            .pic-inputLabel-default.high {
                font-size: 10px;
                line-height: 10px;
                height: var(--pic-densityHighLabelHeight);
                top: 4px;
            }
            .pic-inputLabel-default.inline {
                position: unset;
                width: fit-content;
                height: var(--pic-densityInlineLabelHeight);
                padding: 0px 8px 0px 0px;
                left: 0;
                top: 0;
            }
            .inner-input-default.low {
                height: var(--pic-densityLowInputHeight);
            }
            .inner-input-default.medium {
                height: var(--pic-densityMediumInputHeight);             
            }
            .inner-input-default.high {
                height: var(--pic-densityHighInputHeight);           
            }
            .inner-input-default.inline {
                height: var(--pic-densityInlineInputHeight);
                /* calculated from inputlength - (padding + margin + thin borders) */
                width: calc(var(--pic-inputlength) - 24px);              
            }
            .inner-input-default.inline:focus{
                /* inputlength - (padding + margins + fat borders) */
                width: calc(var(--pic-inputlength) - 24px);
            }
            .inner-input-default.inline.has-icon{
                width: calc(var(--pic-inputlength) - 44px);
            }
            .inner-input-default.inline.has-icon:focus{
                width: calc(var(--pic-inputlength) - 46px);
            }
            .pic-errorIcon.low::before {
                font-family: "Material Design Icons";
                font-size: x-large;
                content: '\u{F0028}'; 
                color: var(--pic-statusErrorColor);
                position: absolute;
                top: calc( (var(--pic-densityLowInputHeight) + 8px) / 2);  
                right: 10px;
                width: 17px;
                height: 17px;        
            }
            .pic-errorIcon.medium::before {
                font-family: "Material Design Icons";
                font-size: x-large;
                content: '\u{F0028}'; 
                color: var(--pic-statusErrorColor);
                position: absolute;
                top: calc( ( var(--pic-densityMediumInputHeight) + 8px) / 2);  
                right: 10px;
                width: 17px;
                height: 17px;        
            }
            .pic-errorIcon.high::before {
                font-family: "Material Design Icons";
                font-size: medium;
                content: '\u{F0028}'; 
                color: var(--pic-statusErrorColor);
                position: absolute;
                top: calc( (var(--pic-densityHighInputHeight) + 4px) / 2);   
                right: 10px;
                width: 17px;
                height: 17px;        
            }
            .pic-errorIcon.inline::before {
                font-family: "Material Design Icons";
                font-size: x-large;
                content: '\u{F0028}'; 
                color: var(--pic-statusErrorColor);
                position: absolute;
                top: calc( (var(--pic-densityInlineInputHeight) - 24px ) / 2);
                right: 10px;
                width: 17px;
                height: 17px;        
            }
            .icon.low {
                top: calc( (var(--pic-densityLowInputHeight) + 17px) / 2);  
                right: 10px;
                width: 16px;
                height: 16px;        
            }
            .icon.medium {
                top: calc( ( var(--pic-densityMediumInputHeight) + 17px) / 2);  
                right: 10px;
                width: 16px;
                height: 16px;        
                
            }
            .icon.high {
                top: calc(((var(--pic-densityHighInputHeight) + 4px) / 2));   
                right: 10px;
                width: 16px;
                height: 16px;        
                
            }
            .icon.inline {
                top: calc( (var(--pic-densityInlineInputHeight) - 16px ) / 2);
                right: 10px;
                width: 16px;
                height: 16px;        
            }
            /* Icons rendered via this <img> path (calendar/clock/lookup/...)
               are baked-in image assets rather than a themeable font glyph,
               so their color can't be reached via --pic-* variables - recolor
               via filter instead. */
            img.icon {
                filter: var(--pic-iconInvert, none);
            }
            img.icon.disabled {
                filter: var(--pic-iconInvert, none) opacity(38%);
            }
            input.inline ~ pic-error{
                width: 0px;
            }
            pic-error{
                width: var(--pic-inputlength, 6rem);
            }
            .fa::before {
                color: var(--pic-onSurfaceHighColor, rgb(98, 99, 100));
            }
            .fa.disabled::before {
                color: var(--pic-disabledColor);
            }
            .hidden-label {
                background-color: transparent;
            }

        `;
        return css `
            ${super.styles}
            ${defaultStyle}
        `;
    }
    connectedCallback() {
        super.connectedCallback();
        if (this.isinput__)
            window.PIC.addInput(this.id_, this);
        if (!this.valid)
            this.valid = new PICValidate([], this);
        if (this.validateData) {
            this.validateData.rules.forEach(rule => {
                this.valid.addByProg(rule);
            });
        }
        else if (this.required_) {
            this.valid.add(new PICRequired(this, { ruleType: 'required' }));
        }
        let ref = this;
        setTimeout(() => {
            ref.actionElm = findAction(ref);
            findActions(ref);
            ref.requestUpdate();
        }, 10);
        function parseCmdDataAttr(rawCmdData, ownerId) {
            let normalized = rawCmdData === null || rawCmdData === void 0 ? void 0 : rawCmdData.trim().replace(/'/g, '"');
            try {
                let parsed = JSON.parse(normalized || '{}');
                if (parsed && parsed.data)
                    return parsed;
            }
            catch (error) {
                console.warn('Invalid cmddata on pic-action', ownerId, rawCmdData);
            }
            return undefined;
        }
        function findAction(iRef) {
            if (iRef.children.length > 0) {
                for (let i = 0; i < iRef.children.length; i++) {
                    if (iRef.children[i].nodeName == 'PIC-ACTION') {
                        return iRef.children[i];
                    }
                }
            }
            return undefined;
        }
        function findActions(iRef) {
            if (iRef.children.length > 0) {
                for (let i = 0; i < iRef.children.length; i++) {
                    if (iRef.children[i].nodeName == 'PIC-ACTION') {
                        let tmpAct = iRef.children[i];
                        let parsedCmdData = parseCmdDataAttr(tmpAct.getAttribute('cmddata'), iRef.id_);
                        if (parsedCmdData) {
                            tmpAct.cmdData = parsedCmdData;
                        }
                        iRef.actionElements.set(tmpAct.trigger_, iRef.children[i]);
                    }
                }
            }
        }
        if (!this.label)
            this.label = this.label_;
        else if (this.label.length == 0)
            this.label = this.label_;
        if (this.required_)
            this.label += ' *';
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        window.PIC.removeInput(this.id_);
    }
    handleCMDUpdate(e) {
        var _a;
        let cmd = e.detail;
        if (e.detail.data)
            cmd = e.detail.data;
        if (typeof cmd === 'string') {
            this.setValue(cmd);
            this.requestUpdate();
        }
        else if ((_a = e.detail.data) === null || _a === void 0 ? void 0 : _a.label) {
            this.label = e.detail.data.label;
        }
    }
    handleCMDClear(e) {
        // this.value = '';
        this.setValue('');
        this.requestUpdate();
    }
    handleCMDCreateError(e) {
        var _a;
        if (this.customError) {
            (_a = this.valid) === null || _a === void 0 ? void 0 : _a.remove(this.customError);
        }
        this.customError = new PICCustomError(this, { ruleType: 'custom', errorMessage: e.detail.data.errormessage });
        if (!this.valid)
            this.valid = new PICValidate([this.customError], this);
        else
            this.valid.add(this.customError);
        this.validate();
        if (e.detail.data.focus)
            this.focus();
        else {
            this.showFullError = true;
            this.requestUpdate();
        }
    }
    handleCMDDeleteError(e) {
        if (this.valid && this.customError) {
            this.customError.setValue('stop');
            this.validate();
            this.valid.remove(this.customError);
            if (this.valid.hasRules() === false)
                this.valid = null;
            this.customError = null;
        }
    }
    addCMDListeners() {
        super.addCMDListeners();
        this.addEventListener('update', this.handleCMDUpdate.bind(this));
        this.addEventListener('clear', this.handleCMDClear.bind(this));
        this.addEventListener('createerror', this.handleCMDCreateError.bind(this));
        this.addEventListener('deleteerror', this.handleCMDDeleteError.bind(this));
    }
    removeCMDListeners() {
        super.removeCMDListeners();
        this.removeEventListener('update', this.handleCMDUpdate.bind(this));
        this.removeEventListener('clear', this.handleCMDClear.bind(this));
        this.removeEventListener('createerror', this.handleCMDCreateError.bind(this));
        this.removeEventListener('deleteerror', this.handleCMDDeleteError.bind(this));
    }
    iconClick(e) {
        if (this.eventId_ > '')
            this.doEvent(e);
        else if (this.actionElements.size > 0) {
            if (this.actionElements.get('click')) {
                this.actionElements.get('click').triggerEvent(e);
            }
            else if (this.actionElements.get('default')) {
                this.actionElements.get('default').triggerEvent(e);
            }
        }
    }
    /** Replaces initial value with decoded URI - used for textfields and textareas */
    decodeInitTextVal() {
        try {
            this.value = decodeURIComponent(this.value);
        }
        catch (e) {
            // console.error('Malformed URI sequence:', this.value);
        }
    }
    focus() {
        this.inputField.focus();
    }
    forceClose() {
        throw new Error('Method not implemented.');
    }
    validate(preventRec = false) {
        var _a, _b, _c;
        if (this.valid) {
            let testRes = this.valid.isInvalid(this.submitValue, preventRec);
            if (typeof testRes == 'boolean') {
                this.validState = [];
            }
            else {
                this.validState = testRes;
            }
            if (this.validState.length === 0 && ((_b = (_a = this.inputField) === null || _a === void 0 ? void 0 : _a.validity) === null || _b === void 0 ? void 0 : _b.customError)) {
                this.inputField.setCustomValidity('');
            }
            if (this instanceof PICDate) {
                if (this.validState.length > 0 && this.hasInvalidDate)
                    this.inputField.setCustomValidity('invalid date');
            }
            let startErrRule = (_c = this.validateData) === null || _c === void 0 ? void 0 : _c.rules.find(rule => rule.ruleType == 'starterror');
            if (startErrRule)
                this.valid.delete(startErrRule);
        }
    }
    validateSubmit() {
        if (this.valid) {
            this.validate();
            if (this.validState.length > 0) {
                return false;
            }
        }
        return true;
    }
    firstUpdated(_changedProperties) {
        var _a;
        super.firstUpdated(_changedProperties);
        if (this.focus_) {
            this.focus();
        }
        if ((_a = this.validateData) === null || _a === void 0 ? void 0 : _a.rules.find(rule => rule.ruleType == 'starterror')) {
            this.validate();
            this.showFullError = true;
            this.requestUpdate();
        }
    }
    renderErr(showErrorBox) {
        if (showErrorBox === true && this.validState.length > 0) {
            return html `<pic-error .parent=${this} .PICErrorData=${this.validState}></pic-error>`;
        }
        else {
            nothing;
        }
    }
    getErrIconClass() {
        return {
            'pic-errorIcon': true,
            ['' + this.density]: true,
        };
    }
    renderErrIcon() {
        if (this.validState.length > 0) {
            //don't render error icon if field has icon
            if (this.icon)
                return html ``;
            this.inputField.style.paddingRight = '26px';
            let compWidth = this.style.width;
            if (this.density === "inline") {
                // subtract padding-left (16px), border-width(2X2px), margins(2X1px) and padding-right(24px) from width to show icon in correct place + keep inputField correct width + prevent text behind error icon
                this.inputField.style.width = `calc(${compWidth} - 26px)`;
            }
            return html `
                <div class=${classMap(this.getErrIconClass())}></div>
            `;
        }
    }
    // getSeconds() tests if the time is bigger than 24:00 => remove the picker icon
    getSeconds() {
        let HOURS = this.value.slice(0, this.value.indexOf(':'));
        let MinutesStart = this.value.indexOf(':') + 1;
        let MinutesEnd = MinutesStart + 2;
        let MINUTES = this.value.slice(MinutesStart, MinutesEnd);
        let seconds = (Number(HOURS) * 3600) + (Number(MINUTES) * 60);
        return seconds;
    }
    renderIcon(isDisabled) {
        let maxHour = 86399;
        if (this.eType == 'old' || this.eType == undefined || this.icon) {
            if (this.eType !== 'old' && this.icon.startsWith('fa')) {
                return html `
                    <i class=${classMap(this.getIconClass())}
                        @click=${(e) => { isDisabled ? '' : this.iconClick(e); }}>
                    </i>
                `;
            }
            else if (this.getSeconds() > maxHour) {
                return html `<img class=${this.disabled_} />`;
            }
            else {
                return html `<img
                        class=${classMap(this.getIconClass())}
                        src="../images/${this.icon}"
                        @click=${(e) => { isDisabled ? '' : this.iconClick(e); }}
                    />
                `;
            }
        }
        else if (this.validState.length > 0) {
            return html `
            <div class="pic-errorIcon">
            </div>    
            `;
        }
    }
    setHasEllipsis() {
        this.hasEllipsis = this.inputField.offsetWidth < this.inputField.scrollWidth;
    }
    changeHandler(e) {
        var _a, _b;
        if (this.customError && this.submitValue !== this.initValue_) {
            (_a = this.valid) === null || _a === void 0 ? void 0 : _a.remove(this.customError);
            this.customError = null;
            this.validate();
        }
        if (this.changeEvent > '') {
            if (this.initValue_ !== this.submitValue) {
                this.initValue_ = this.submitValue; //Fixes initValue not being sat when using commands instead of re-rendering full page
                if (this.isRunningSubmitEvent) {
                    this.isRunningSubmitEvent = false;
                    return true;
                }
                let focusElm;
                if (e instanceof FocusEvent) {
                    focusElm = e.relatedTarget;
                }
                else if (e instanceof KeyboardEvent) {
                    if (e.key == 'Tab') {
                        let elmLst = Array.from((_b = this.getRootNode()) === null || _b === void 0 ? void 0 : _b.querySelectorAll('[piccomponent]:not([disabled]), input[type="button"]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="number"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), input[type="color"]:not([disabled]), select:not([disabled])'));
                        let idx = elmLst.indexOf(this);
                        if (!e.shiftKey) {
                            if (idx !== -1) {
                                if (idx == elmLst.length - 1) {
                                    focusElm = elmLst[0];
                                }
                                else {
                                    focusElm = elmLst[idx + 1];
                                }
                            }
                        }
                        else {
                            if (idx !== -1) {
                                if (idx == 0) {
                                    focusElm = elmLst[elmLst.length - 1];
                                }
                                else {
                                    focusElm = elmLst[idx - 1];
                                }
                            }
                        }
                    }
                }
                if (focusElm) {
                    //Send in the next focusable element in the list so it can be used in the backend with setFocus()
                    window.submitFocusElm = focusElm;
                }
                let newSuperEvent = { detail: { uncomposed: e, elm: this }, bubbles: true, composed: true };
                submitEventHandler(new CustomEvent('mySuperAwesomeEvent', newSuperEvent), this.changeEvent);
                //submitEventHandler(e, this.changeEvent);
                return true;
            }
        }
        else if (this.actionElements.size > 0) {
            if (this.actionElements.get('change')) {
                this.actionElements.get('change').triggerEvent(e);
                return true;
            }
            else if (this.actionElements.get('default')) {
                this.actionElements.get('default').triggerEvent(e);
                return true;
            }
        }
        return false;
    }
    focusHandler(mode) {
        var _a;
        let errorContainer = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('pic-error');
        let errorIcon = errorContainer === null || errorContainer === void 0 ? void 0 : errorContainer.previousElementSibling;
        if (errorIcon) {
            if (mode === 'in') {
                if (errorIcon && errorIcon.classList.contains('pic-errorIcon')) {
                    errorIcon.style.setProperty('display', 'block');
                }
                this.showFullError = true;
                this.requestUpdate();
            }
            if (mode === 'out') {
                if (errorIcon && errorIcon.classList.contains('pic-errorIcon')) {
                    errorIcon.style.setProperty('display', 'none');
                }
                this.showFullError = false;
                this.requestUpdate();
            }
        }
    }
    pullbackHandler(e) {
        this.inputField.value = e.detail.value;
        this.changeHandler();
    }
    keyHandler(e) {
        if (this.actionElements.size > 0) {
            if (this.actionElements.get('change')) {
                this.actionElements.get('change').triggerEvent(e);
                return true;
            }
            else if (this.actionElements.get('default')) {
                this.actionElements.get('default').triggerEvent(e);
                return true;
            }
        }
        return false;
    }
    enterSubmit(e) {
        let firstSubmit;
        if (e.key == 'Enter') {
            this.isRunningSubmitEvent = true;
            /* added this to make it possible to override keypress action */
            if (this.selfAction != null) {
                this.selfAction.triggerEvent(e);
            }
            else {
                // in modal web3
                if (this.getRootNode().firstElementChild instanceof PICModal) {
                    if (this.initValue_ !== this.submitValue && this.changeEvent > '') {
                        this.isRunningSubmitEvent = false;
                        this.changeHandler(e);
                    }
                    else if (this.getRootNode().firstElementChild.submitButton) {
                        firstSubmit = this.getRootNode().firstElementChild.submitButton;
                        if (firstSubmit) {
                            firstSubmit.doEvent(e);
                            return;
                        }
                        ;
                    }
                }
                // in modal web2
                else if (this.getRootNode().firstElementChild.dom) {
                    firstSubmit = this.getRootNode().firstElementChild.dom.shadowRoot.querySelector('input[type=submit]');
                    if (this.initValue_ !== this.submitValue && this.changeEvent > '') {
                        this.isRunningSubmitEvent = false;
                        this.changeHandler(e);
                    }
                    if (firstSubmit) {
                        firstSubmit.click();
                        return;
                    }
                }
                else if (this.initValue_ !== this.submitValue && this.changeEvent > '') {
                    this.isRunningSubmitEvent = false;
                    this.changeHandler(e);
                }
                // in lightDom regular button
                else if (document.querySelector('input[type=submit]')) {
                    firstSubmit = document.querySelector('input[type=submit]');
                    if (firstSubmit) {
                        firstSubmit.click();
                        return;
                    }
                    ;
                    // in lightDom PICButton
                }
                else if (PIC.getInstance.picSubmitButton) {
                    firstSubmit = PIC.getInstance.picSubmitButton;
                    if (firstSubmit) {
                        firstSubmit.doEvent(e);
                        return;
                    }
                    ;
                }
            }
        }
    }
    getInputLabelClass() {
        return {
            'pic-caption': this.eType == 'old' || this.eType == undefined ? false : true,
            'pic-inputLabel-old': this.eType == 'old' || this.eType == undefined,
            'hidden-label': typeof this.label == 'object' && this.label.strings[0] === String.fromCharCode(160) && this.eType != 'old',
            'pic-inputLabel-default': this.eType != 'old',
            'disabled': this.disabled_ && this.eType !== 'switch',
            'disabled-lable': this.disabled_ && this.eType === 'switch',
            ['' + this.density]: this.eType == 'spinner' || this.density == 'inline' || this.density == 'high' || (this.eType == 'text' && (this.placeholder == null || this.placeholder.length === 0))
        };
    }
    getInnerInputClass() {
        return {
            'inner-input': true,
            'pic-body1': this.eType != 'old' && this.density == 'low' || this.density == 'medium',
            'pic-body2': this.eType != 'old' && this.density == 'high' || this.density == 'inline',
            'inner-input-old': this.eType == 'old' || this.eType == undefined,
            'has-icon': this.icon.length > 0,
            'inner-input-default': this.eType != 'old',
            ['' + this.density]: true
        };
    }
    //="fa fa-solid fa-calendar-days icon ${this.density}"
    getIconClass() {
        if (this.density !== 'old') {
            return {
                icon: true,
                fa: true,
                'fa-solid': this instanceof PICDate || this instanceof PICDualDate,
                'fa-calendar-days': this instanceof PICDate || this instanceof PICDualDate,
                'fa-regular': this instanceof PICTime,
                'fa-clock': this instanceof PICTime,
                disabled: this.disabled_,
                ['' + this.density]: true
            };
        }
        else {
            return {
                icon: true,
                ['' + this.density]: this.eType != 'old'
            };
        }
    }
    getContainerStyle() {
        let styles = [];
        styles.push({ 'position': 'relative' });
        /*this.width == 160 && (this.eType == 'old' || this.eType == undefined) ? this.width = 10 : '';
        styles.push({'width': this.width + (this.eType == 'old' || this.eType == undefined ? 'rem' : 'px')} as StyleInfo);
        this.width == -1 ? styles.push({'width': '100%'} as StyleInfo) : '';*/
        if (this.density == 'inline') {
            styles.push({ 'flex-flow': 'row' });
            styles.push({ 'align-items': 'center' });
            styles.push({ 'width': 'fit-content' });
        }
        return styles.length > 0 ? styles.reduce((total, current) => total = Object.assign(Object.assign({}, total), current)) : {};
    }
    getComponentStyle() {
        let styles = [];
        styles.push({ 'min-width': this.width });
        styles.push({ 'width': this.width });
        styles.push({ 'max-width': this.width });
        return styles.length > 0 ? styles.reduce((total, current) => total = Object.assign(Object.assign({}, total), current)) : {};
    }
    setComponentInlineStyle(min, max) {
        this.style.setProperty('min-width', min ? min : this.width);
        this.style.setProperty('width', this.width);
        this.style.setProperty('max-width', max ? max : this.width);
        this.style.setProperty('--pic-inputlength', this.width);
    }
    adjustRenderedWidth() {
        var _a;
        if (PIC.getInstance.webVersion == '3') {
            let lbl = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('label');
            // let componentWidth = window.getComputedStyle(this).getPropertyValue('width') ? parseInt(window.getComputedStyle(this).getPropertyValue('width')) : 0;
            // if(lblWidth >= componentWidth) this.width = lblWidth + 30;
            let lblWidth = lbl ? parseInt(window.getComputedStyle(lbl).getPropertyValue('width')) : 160;
            if (this.width.match(/%$/g))
                return;
            let parsedWidth = 0;
            if (this.width.match(/px$/g))
                parsedWidth = parseFloat(this.width);
            if (this.width.match(/vh$/g))
                parsedWidth = parseFloat(this.width) * window.innerHeight / 100;
            if (this.width.match(/vw$/g))
                parsedWidth = parseFloat(this.width) * window.innerWidth / 100;
            if (this.width.match(/rem$/g))
                parsedWidth = parseFloat(this.width) * 16;
            if (this.width.match(/em$/g))
                parsedWidth = parseFloat(this.width) * parseFloat(window.getComputedStyle(this).getPropertyValue('font-size'));
            if (lblWidth >= parsedWidth)
                this.width = lblWidth + 30;
        }
    }
    render() {
        this.setComponentInlineStyle();
        return html `
            ${this.renderCSS(true)}
            <div style=${styleMap(this.getContainerStyle())} class="container">
                <label class=${classMap(this.getInputLabelClass())}>
                    ${this.label}
                </label>
                <input
                    class=${classMap(this.getInnerInputClass())}
                    ?disabled=${this.disabled_}
                    ?contenteditable=${this.readonly_}
                    tabindex=${this.readonly_ ? -1 : 1}
                    placeholder=${this.placeholder}
                    .value=${this.value}
                    @input=${(e) => (this.value = e.target.value)}
                    @keyup=${this.keyHandler}
                    @keydown=${this.enterSubmit}
                    @pullback=${this.pullbackHandler}
                    @focusin=${() => this.focusHandler('in')}
                    @focusout=${(e) => { this.changeHandler(e); this.focusHandler('out'); }}
                />
                ${this.icon.length > 0 ? this.renderIcon(this.disabled_) : ''}
            </div>
            ${this.tooltip_ ? html `<pic-tooltip>${this.tooltip_}</pic-tooltip>` : ''}
        `;
    }
};
PICInput.oldStyle = true;
__decorate([
    property({ converter: stringDecoder })
], PICInput.prototype, "value", void 0);
__decorate([
    property({ converter: stringDecoder })
], PICInput.prototype, "placeholder", void 0);
__decorate([
    property({ converter: labelDecoder })
], PICInput.prototype, "label", void 0);
__decorate([
    property({ converter: stringDecoder })
], PICInput.prototype, "icon", void 0);
__decorate([
    property({ converter: json2Validate })
], PICInput.prototype, "validateData", void 0);
__decorate([
    property({ converter: stringDecoder })
], PICInput.prototype, "changeEvent", void 0);
__decorate([
    property({ converter: booleanDecoder, attribute: 'focus' })
], PICInput.prototype, "focus_", void 0);
__decorate([
    property({ type: Array })
], PICInput.prototype, "validState", void 0);
__decorate([
    query('.inner-input')
], PICInput.prototype, "inputField", void 0);
__decorate([
    property({ converter: stringDecoderLC, attribute: 'etype' })
], PICInput.prototype, "eType", void 0);
__decorate([
    property({ converter: stringDecoderLC, attribute: 'density' })
], PICInput.prototype, "density", void 0);
__decorate([
    property({ type: String, attribute: 'width', reflect: false })
], PICInput.prototype, "width", null);
PICInput = __decorate([
    customElement('pic-input')
], PICInput);
export { PICInput };
//# sourceMappingURL=PICInput.js.map